/**
 * Enum for DRM Types.
 */
export enum DrmScheme {
  /**
   * Indicates that the content is UnEncrypted / Non-Protected.
   */
  NONE = 'none',

  /**
   * Indicates that the content is protected using Widevine DRM Scheme.
   */
  WIDEVINE = 'widevine',

  /**
   * Indicates that the content is protected using PlayReady DRM Scheme.
   */
  PLAYREADY = 'playready',

  /**
   * Indicates that the content is protected using Fairplay DRM Scheme.
   */
  FAIRPLAY = 'fairplay',

  /**
   * Indicates that the content is protected using ClearKey DRM Scheme.
   */
  CLEARKEY = 'clearkey',
}
